import React, { useEffect, Fragment } from "react";
import {Link} from 'react-router-dom';
import {ArrowUpRight, ChevronLeft, ChevronRight, Grid} from 'react-feather';

import pfizer from '../../assets/images/pfizer-single-service-banner.png';

const PfizerKeepItReal = (props) => {

    // Adding custom class to body 
    useEffect(() =>{
        props.location.pathname === '/' ? document.body.classList.add("home-class") : document.body.classList.add("custom-class");
    })

    return (
        <Fragment>
            <section id="single-project-wrapper">
                <div className="single-project">
                    <div className="container-fluid">
                        <div className="w-full">
                            <div className="single-project-image">
                                <img className="object-cover h-max w-screen" src={pfizer} alt="Featured" />
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="max-w-default w-default px-12 py-28 lg:py-24 md:py-16 sm:py-4 container-wrapper">
                            <div className="single-project-details">
                                <div className='breadcrumbs pb-4'>
                                    <li><Link to='/'>Home</Link> <span>{'>'}</span> <Link to='/our-work'>Our Work</Link><span>{'>'}</span><Link to='/pfizer-keep-it-real' className='current'>Pfizer</Link></li>
                                </div>
                                <div className="flex lg:flex-row md:flex md:flex-col sm:flex-col single-project-details-wrapper">
                                    <div className="single-project-details-left grid grid-rows-1 grid-cols-2 gap-20">
                                        <div className="details-project-name">
                                            <h3 className="heading5 pb-8">Project Name</h3>
                                            <h1>Pfizer</h1>
                                        </div>
                                        <div>
                                            <h3 className="heading5 pb-8">Type</h3>
                                            <p>Social Media</p>
                                        </div>
                                        {/* <div>
                                            <h3 className="heading5 pb-6">Type</h3>
                                            <p>Social Media</p>
                                        </div> */}
                                        {/* <div>
                                            <h3 className="heading5 pb-6">Website</h3>
                                            <p>lorem Ipsum</p>
                                        </div> */}
                                    </div>
                                    <div className="single-project-details-right lg:pt-0 lg:py-16 md:pt-12">
                                        <div>
                                            <h2 className="heading5 pb-8">The Ask</h2>
                                            <p>Build awareness and create a healthy conversation around Erectile Dysfunction and its treatment, and impact sales.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="single-project-body">
                                    <h2 className="heading4 pb-8">
                                        What we did
                                    </h2>
                                    <p>With the <strong>#KeepItReal</strong> campaign, we encouraged women to engage with their partners, normalize conversations around erectile dysfunction and treat it for what it is - a treatable condition. With the right counsel from doctors and the means to protect one’s identity while seeking treatment, we were able to provide patients a route to seek consultations and convert them into customers. A frictionless digital path to purchase was enabled in partnering up with established E-pharmacies, allowing for consumers to seek treatment for a condition that is often taboo and joked about. Quirky creatives and supplemental medical advice led more people to seek out appropriate measures as opposed to ignoring or belittling a touchy subject.</p><br/>
                                    <p>For navigating a complex subject and binding advertising platform regulations responsibly, the campaign went on to win several industry awards.</p>
                                  
                                    <h2 className="heading4 pt-16 pb-8 what-campaign-achived">
                                        What the campaign achieved
                                    </h2>
                                    <div className="results">
                                        <div>
                                            <h1>300M +</h1>
                                            <h2>Reach</h2>
                                        </div>
                                        <div>
                                            <h1>16M +</h1>
                                            <h2>Video Views</h2>
                                        </div>
                                        <div>
                                            <h1>235K +</h1>
                                            <h2>Direct Engagement</h2>
                                        </div>
                                    </div>
                                    
                                    <div className="pagination">
                                        <div><Link to='/upes-shakti'><ChevronLeft/><span>Previous</span></Link></div>
                                        <div><Link to='/our-work'><Grid/><span>All Projects</span></Link></div>
                                        <div><Link to='/my-cams-app'><ChevronRight/><span>Next</span></Link></div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Footer CTA Ribbon */}
            <section id='take-next-leap' key='single-project'>
                <div className='take-next-leap'>
                    <div className='take-next-leap__left'>
                        <h1 className="heading4 black">Let’s create <span>impact together.</span></h1>
                    </div>
                    <div className='take-next-leap__right'>
                        <p><Link to='/contact-us'>Contact us today<ArrowUpRight/></Link></p>
                    </div>
                </div>
            </section>
            {/* Footer CTA Ribbon */}
        </Fragment>
    );
};

export default PfizerKeepItReal;